"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationErrorMessage = exports.getDayStatus = exports.getButtonText = exports.ECalendarValidationError = void 0;
exports.processDaysAvailability = processDaysAvailability;
var _dateFns = require("date-fns");
const MAX_DAYS = 30;
function processDaysAvailability(availabilityArray, from, to) {
  // Если выбран диапазон дат или ни одна дата не выбрана,
  // возвращаем исходные данные без изменений
  if (!from || to) {
    return availabilityArray;
  }
  const today = new Date();
  const fromIndex = (0, _dateFns.differenceInCalendarDays)(from, today);

  // Находим границы непрерывного доступного диапазона
  const rangeStart = findContinuousRangeStart(availabilityArray, fromIndex);
  const rangeEnd = findContinuousRangeEnd(availabilityArray, fromIndex);

  // Создаем результат: сохраняем значения внутри диапазона, обнуляем снаружи
  const result = [...availabilityArray];
  for (let i = 0; i < result.length; i++) {
    if (i < rangeStart || i > rangeEnd) {
      result[i] = 0;
    } else {
      result[i] = 1;
    }
  }
  return result;
}

/**
 * Находит начало непрерывного доступного диапазона
 */
function findContinuousRangeStart(availabilityArray, fromIndex) {
  // Идем влево от выбранной даты
  let start = fromIndex;
  while (start > 0) {
    const prevDay = availabilityArray[start - 1];

    // Если предыдущий день занят или только для выезда, то принимаем текущий день как начало диапазона
    if (prevDay === 0 || prevDay === 2) {
      return start;
    }
    start--;
  }

  // Сработает только если все дни до начала календаря свободны
  return start;
}

/**
 * Находит конец непрерывного доступного диапазона
 */
function findContinuousRangeEnd(availabilityArray, fromIndex) {
  // Особый случай: если выбран день "только выезд", то принимаем ее как конец диапазона
  if (availabilityArray[fromIndex] === 2) {
    return fromIndex;
  }

  // Идем вправо от выбранной даты
  let end = fromIndex;
  while (end < availabilityArray.length - 1) {
    const nextDay = availabilityArray[end + 1];

    // Если следующий день занят, то принимаем текущий день как конец диапазона
    if (nextDay === 0) {
      return end;
    }

    // Если следующий день только для выезда, то принимаем следующий день как конец диапазона
    if (nextDay === 2) {
      return end + 1;
    }
    end++;
  }

  // Сработает только если все дни до конца календаря свободны
  return end;
}
const getDayStatus = (availabilityArray, date) => {
  const today = new Date();
  const currentDateIndex = (0, _dateFns.differenceInCalendarDays)(date, today);

  /**
   * Даты раньше "сегодня" недоступны
   */
  if (currentDateIndex < 0) {
    return 0;
  }

  /** Если календарь проверяет даты за пределами проверенных на доступность, возвращать их доступными */
  if (availabilityArray[currentDateIndex] === undefined || currentDateIndex < 0) {
    return 1;
  }

  // 0 – занято, 1 – свободно, 2 - только выезд
  return availabilityArray[currentDateIndex];
};
exports.getDayStatus = getDayStatus;
let ECalendarValidationError = exports.ECalendarValidationError = /*#__PURE__*/function (ECalendarValidationError) {
  ECalendarValidationError["NO_RANGE"] = "noRange";
  ECalendarValidationError["MIN_RANGE"] = "minRange";
  ECalendarValidationError["MAX_RANGE"] = "maxRange";
  ECalendarValidationError["ONLY_CHECKOUT"] = "onlyCheckout";
  return ECalendarValidationError;
}({});
const ValidationRulesErrorMap = {
  [ECalendarValidationError.NO_RANGE]: 'Даты не выбраны',
  [ECalendarValidationError.MIN_RANGE]: 'Выберите разные дни заезда и выезда',
  [ECalendarValidationError.MAX_RANGE]: 'Максимум 30 ночей',
  [ECalendarValidationError.ONLY_CHECKOUT]: 'Доступен только выезд'
};

// Тут важен порядок тк одновременно может быть показано только одно сообщение, будет показано первое найденое
const validationRules = [[ECalendarValidationError.NO_RANGE, selection => {
  const {
    startDate,
    endDate
  } = selection;
  return !!startDate || !!endDate;
}], [ECalendarValidationError.ONLY_CHECKOUT, selection => {
  const {
    startDate,
    daysAvailability
  } = selection;
  if (!startDate) {
    return false;
  }
  const index = (0, _dateFns.differenceInCalendarDays)(startDate, new Date());

  // Если в определенную дату один гость будет заселяться,
  // то другой гость может выбрать эту дату только как дату выезда, а заехать не может.
  // Проверяем что первая выбранная дата не является "только для выезда" (статус 2)
  // 0 – занято, 1 – свободно, 2 - только выезд
  return daysAvailability[index] !== 2;
}], [ECalendarValidationError.MIN_RANGE, selection => {
  const {
    startDate,
    endDate
  } = selection;
  if (!startDate || !endDate) {
    return false;
  }
  return Math.abs((0, _dateFns.differenceInCalendarDays)(startDate, endDate)) > 0;
}], [ECalendarValidationError.MAX_RANGE, selection => {
  const {
    startDate,
    endDate
  } = selection;
  if (!startDate || !endDate) {
    return false;
  }
  return Math.abs((0, _dateFns.differenceInCalendarDays)(startDate, endDate)) <= MAX_DAYS;
}]];
const getValidationErrorMessage = selection => {
  const invalidRule = validationRules.find(_ref => {
    let [, predicate] = _ref;
    return !predicate(selection);
  });
  if (!invalidRule) {
    return [undefined, ''];
  }
  return [invalidRule[0], ValidationRulesErrorMap[invalidRule[0]]];
};
exports.getValidationErrorMessage = getValidationErrorMessage;
const getButtonText = (firstDateSelected, rangeSelected) => {
  if (rangeSelected) {
    return 'Готово';
  } else if (firstDateSelected) {
    return 'Выберите дату выезда';
  }
  return 'Выберите даты';
};
exports.getButtonText = getButtonText;